export const SET_CUSTOMER_NAME_REDUCER = 'SET_CUSTOMER_NAME_REDUCER';
export const SET_CUSTOMER_NAME_REQUEST = 'SET_CUSTOMER_NAME_REQUEST';
export const SET_CUSTOMER_NAME_SUCCESS = 'SET_CUSTOMER_NAME_SUCCESS';
export const SET_CUSTOMER_NAME_FAILURE = 'SET_CUSTOMER_NAME_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/customer_name.constants.js